module.exports = __webpack_public_path__ + "img/gb-nir.579b2ca2.png";